export const getOcplcProductFamily = `query GetOcplcProductFamily($filter: OcplcKmatRequest!) {
    ocplcKmatProductFamily(filter: $filter) {
      productFamily {
        kmatId
        status
        author
      }
    }
  }`

export const filterOcplcKmatforPG = `query GetKmatsForPg($filter: OcplcKmatForPGRequest!) {
  getKmatsForPg(filter: $filter) {
    kmatIds {
      kmatId
      kmatDesc
    }
  }
}`;